var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls,style:({width: _vm.size, height: _vm.size})},[_c('span',{class:_vm.extClass})])}
var staticRenderFns = []

export { render, staticRenderFns }